"use client";

import type { LeadFlowRichTextContent } from "@homeinstead/schemas";

import { LeadFlowPortableText } from "./LeadFlowPortableText";

type RichTextItemProps = {
  item: { text?: LeadFlowRichTextContent | null };
};

function RichTextItem({ item }: RichTextItemProps) {
  return <LeadFlowPortableText value={item.text} />;
}

export { RichTextItem };
